// import Vue from "vue";
import axios from "axios";

const state = () => ({
  sectoriales: [],
  destinos: [],
  jerarquias: [],
  causas: [],
  dependencias: [],
  departamentales: [],
  departamentos: [],
  isLoading: false
});

const mutations = {
  SET_SECTORIALES(state, sectoriales) {
    state.sectoriales = sectoriales;
  },
  SET_DESTINOS(state, destinos) {
    state.destinos = destinos;
  },
  SET_JERARQUIAS(state, jerarquias) {
    state.jerarquias = jerarquias;
  },
  SET_CAUSAS(state, causas) {
    state.causas = causas;
  },
  SET_DEPENDENCIAS(state, dependencias) {
    state.dependencias = dependencias;
  },
  SET_DEPARTAMENTALES(state, departamentales) {
    state.departamentales = departamentales;
  },
  SET_DEPARTAMENTOS(state, departamentos) {
    state.departamentos = departamentos;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  }
};

const actions = {
  setLoading({ commit }, isLoading) {
    commit('SET_LOADING', isLoading);
  },
  
  async getCausas({ commit, state }, refresh) {
    try {
      if (state.causas.length !== 0 && !refresh) {
        console.log("Las causas ya están cargadas");
        return state.causas;
      }

      const resp = await axios.get(
        process.env.VUE_APP_BASE_URL + "causas"
      );

      // Verificar si resp.data es un array
      let causas = [];
      if (Array.isArray(resp.data)) {
        causas = resp.data.map((elem) => ({
          ...elem,
          // Aseguramos que dataText sea el campo 'causa'
          dataText: elem.causa || "",
          // Usamos ActuacionID como dataValue si existe, de lo contrario usamos id
          dataValue: elem.ActuacionID || elem.id,
          // Aseguramos que todos los campos importantes estén disponibles
          ActuacionID: elem.ActuacionID || "",
          DepartamentalID: elem.DepartamentalID || "",
          DependenciaID: elem.DependenciaID || "",
          TiposumarioID: elem.TiposumarioID || "",
          causa: elem.causa || "",
          comisaria: elem.comisaria || "",
          departamental: elem.departamental || "",
          departamento: elem.departamento || "",
          dia: elem.dia || "",
          fecha_del_hecho: elem.fecha_del_hecho || null,
          hora: elem.hora || "",
          lat: elem.lat || null,
          lng: elem.lng || null,
          legajo: elem.legajo || ""
        }));
      } else if (typeof resp.data === 'object' && resp.data !== null) {
        // Si es un objeto, intentamos convertirlo a array
        console.log("La respuesta de causas no es un array, intentando convertir:", resp.data);
        const dataArray = Object.values(resp.data);
        if (Array.isArray(dataArray)) {
          causas = dataArray.map((elem) => ({
            ...elem,
            dataText: elem.causa || "",
            dataValue: elem.ActuacionID || elem.id,
            ActuacionID: elem.ActuacionID || "",
            DepartamentalID: elem.DepartamentalID || "",
            DependenciaID: elem.DependenciaID || "",
            TiposumarioID: elem.TiposumarioID || "",
            causa: elem.causa || "",
            comisaria: elem.comisaria || "",
            departamental: elem.departamental || "",
            departamento: elem.departamento || "",
            dia: elem.dia || "",
            fecha_del_hecho: elem.fecha_del_hecho || null,
            hora: elem.hora || "",
            lat: elem.lat || null,
            lng: elem.lng || null,
            legajo: elem.legajo || ""
          }));
        } else {
          console.error("No se pudo convertir la respuesta de causas a un array");
        }
      } else {
        console.error("La respuesta de causas no es un array ni un objeto:", resp.data);
      }
      
      console.log("Causas cargadas:", causas);

      commit("SET_CAUSAS", causas);
      return causas;
    } catch (e) {
      console.error("Error al cargar las causas:", e);
      throw e;
    }
  },

  async getDependencias({ commit, state }, refresh) {
    try {
      if (state.dependencias.length !== 0 && !refresh) {
        console.log("Las dependencias ya están cargadas");
        return state.dependencias;
      }

      const resp = await axios.get(
        process.env.VUE_APP_BASE_URL + "dependencias"
      );

      // Verificar si resp.data es un array
      let dependencias = [];
      if (Array.isArray(resp.data)) {
        dependencias = resp.data.map((elem) => ({
          ...elem,
          // Aseguramos que dataText sea el campo 'dependencia'
          dataText: elem.dependencia || "",
          // Usamos DependenciaID como dataValue
          dataValue: elem.DependenciaID || elem.id,
          // Aseguramos que todos los campos importantes estén disponibles
          DependenciaID: elem.DependenciaID || "",
          DepartamentalID: elem.DepartamentalID || "",
          dependencia: elem.dependencia || "",
          departamental: elem.departamental || ""
        }));
      } else if (typeof resp.data === 'object' && resp.data !== null) {
        // Si es un objeto, intentamos convertirlo a array
        console.log("La respuesta de dependencias no es un array, intentando convertir:", resp.data);
        const dataArray = Object.values(resp.data);
        if (Array.isArray(dataArray)) {
          dependencias = dataArray.map((elem) => ({
            ...elem,
            dataText: elem.dependencia || "",
            dataValue: elem.DependenciaID || elem.id,
            DependenciaID: elem.DependenciaID || "",
            DepartamentalID: elem.DepartamentalID || "",
            dependencia: elem.dependencia || "",
            departamental: elem.departamental || ""
          }));
        } else {
          console.error("No se pudo convertir la respuesta de dependencias a un array");
        }
      } else {
        console.error("La respuesta de dependencias no es un array ni un objeto:", resp.data);
      }
      
      console.log("Dependencias cargadas:", dependencias);

      commit("SET_DEPENDENCIAS", dependencias);
      return dependencias;
    } catch (e) {
      console.error("Error al cargar las dependencias:", e);
      throw e;
    }
  },

  async getDepartamentales({ commit, state }, refresh) {
    try {
      if (state.departamentales.length !== 0 && !refresh) {
        console.log("Las departamentales ya están cargadas");
        return state.departamentales;
      }

      const resp = await axios.get(
        process.env.VUE_APP_BASE_URL + "departamentales"
      );

      // Verificar si resp.data es un array
      let departamentales = [];
      if (Array.isArray(resp.data)) {
        departamentales = resp.data.map((elem) => ({
          ...elem,
          // Aseguramos que dataText sea el campo 'departamental'
          dataText: elem.departamental || "",
          // Usamos DepartamentalID como dataValue
          dataValue: elem.DepartamentalID || elem.id,
          // Aseguramos que el campo DepartamentalID esté disponible
          DepartamentalID: elem.DepartamentalID || "",
          departamental: elem.departamental || ""
        }));
      } else if (typeof resp.data === 'object' && resp.data !== null) {
        // Si es un objeto, intentamos convertirlo a array
        console.log("La respuesta de departamentales no es un array, intentando convertir:", resp.data);
        const dataArray = Object.values(resp.data);
        if (Array.isArray(dataArray)) {
          departamentales = dataArray.map((elem) => ({
            ...elem,
            dataText: elem.departamental || "",
            dataValue: elem.DepartamentalID || elem.id,
            DepartamentalID: elem.DepartamentalID || "",
            departamental: elem.departamental || ""
          }));
        } else {
          console.error("No se pudo convertir la respuesta de departamentales a un array");
        }
      } else {
        console.error("La respuesta de departamentales no es un array ni un objeto:", resp.data);
      }
      console.log("Departamentales cargadas:", departamentales);

      commit("SET_DEPARTAMENTALES", departamentales);
      return departamentales;
    } catch (e) {
      console.error("Error al cargar las departamentales:", e);
      throw e;
    }
  },

  async getDepartamentos({ commit, state }, refresh) {
    try {
      if (state.departamentos.length !== 0 && !refresh) {
        console.log("Los departamentos ya están cargados");
        return state.departamentos;
      }

      const resp = await axios.get(
        process.env.VUE_APP_BASE_URL + "departamentos"
      );

      // Verificar si resp.data es un array
      let departamentos = [];
      if (Array.isArray(resp.data)) {
        // Caso especial: si es un array de strings (como has mostrado)
        if (resp.data.length > 0 && typeof resp.data[0] === 'string') {
          console.log("Detectado array de strings para departamentos");
          departamentos = resp.data.map((nombreDepartamento, index) => ({
            // Creamos un objeto con la estructura necesaria
            id: index.toString(),
            dataText: nombreDepartamento,
            dataValue: index.toString(),
            departamento: nombreDepartamento
          }));
        } else {
          // Caso normal: array de objetos
          departamentos = resp.data.map((elem) => ({
            ...elem,
            dataText: elem.departamento || "",
            dataValue: elem.id,
            departamento: elem.departamento || ""
          }));
        }
      } else if (typeof resp.data === 'object' && resp.data !== null) {
        // Si es un objeto, intentamos convertirlo a array
        console.log("La respuesta de departamentos no es un array de objetos, intentando convertir:", resp.data);
        const dataArray = Object.values(resp.data);
        if (Array.isArray(dataArray)) {
          // Si son strings
          if (dataArray.length > 0 && typeof dataArray[0] === 'string') {
            departamentos = dataArray.map((nombreDepartamento, index) => ({
              id: index.toString(),
              dataText: nombreDepartamento,
              dataValue: index.toString(),
              departamento: nombreDepartamento
            }));
          } else {
            departamentos = dataArray.map((elem) => ({
              ...elem,
              dataText: elem.departamento || "",
              dataValue: elem.id,
              departamento: elem.departamento || ""
            }));
          }
        } else {
          console.error("No se pudo convertir la respuesta a un array");
        }
      } else {
        console.error("La respuesta de departamentos no es un array ni un objeto:", resp.data);
      }
      
      console.log("Departamentos cargados:", departamentos);

      commit("SET_DEPARTAMENTOS", departamentos);
      return departamentos;
    } catch (e) {
      console.error("Error al cargar los departamentos:", e);
      throw e;
    }
  },
  async getSectoriales({ commit, state }, refresh) {
    try {
      console.log("entra");
      
      if (state.sectoriales.length !== 0 && !refresh) {
        console.log("Los sectoriales ya están cargados");
        return;
      }

      const resp = await axios.get(
        process.env.VUE_APP_BACKEND_ENVIRONMENT + "/sectoriales"
      );

      const sectoriales = resp.data.map((elem) => ({
        ...elem,
        dataText: elem.sectorial,
        dataValue: elem.id,
      }));
      console.log("Sectoriales cargados:", sectoriales);

      commit("SET_SECTORIALES", sectoriales);
    } catch (e) {
      console.error("Error al cargar los sectoriales:", e);
    }
  },

  async getDestinos({ commit, state }, refresh) {
    try {
      if (state.destinos.length !== 0 && !refresh) {
        console.log("Los destinos ya están cargados");
        return;
      }

      const resp = await axios.get(
        process.env.VUE_APP_BACKEND_ENVIRONMENT + "/destinos"
      );
    console.log("Respuesta de destinos", resp);
      const destinos = resp.data.map((elem) => ({
        ...elem,
        dataText: elem.destino,
        dataValue: elem.id,
      }));

      console.log("Destinos cargados:", destinos);
      commit("SET_DESTINOS", destinos);
    } catch (e) {
      console.error("Error al cargar los destinos:", e);
    }
  },
  async getJerarquias({ commit, state }, refresh) {
    try {
      if (state.jerarquias.length !== 0 && !refresh) {
        console.log("Los jerarquias ya están cargados");
        return;
      }

      const resp = await axios.get(
        process.env.VUE_APP_BACKEND_ENVIRONMENT + "/jerarquia"
      );
    console.log("Respuesta de jerarquias", resp);
      const jerarquias = resp.data.map((elem) => ({
        ...elem,
        dataText: elem.jerarquia,
        dataValue: elem.id,
      }));

      console.log("jerarquias cargados:", jerarquias);
      commit("SET_JERARQUIAS",  jerarquias);
    } catch (e) {
      console.error("Error al cargar los jerarquias:", e);
    }
  },
};

const getters = {
  getSectoriales: (state) => state.sectoriales,
  getDestinos: (state) => state.destinos,
  getJerarquias: (state) => state.jerarquias,
  getCausas: (state) => state.causas,
  getDependencias: (state) => state.dependencias,
  getDepartamentales: (state) => state.departamentales,
  getDepartamentos: (state) => state.departamentos,
  isLoading: (state) => state.isLoading
};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
